// Drop-in replacement for `<img>` that resolves authorized server media URLs
// (e.g. `/v0/file/s/<id>?...`) to the signed CDN URL the server redirects to.
//
// Browsers don't always reliably follow 307 redirects for image sources, so
// we resolve the redirect ourselves and use the final CDN URL as `src`.
import React from 'react';

import { needsResolution, resolveSignedUrl } from '../lib/signed-url.js';

export default class SignedImage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      resolvedSrc: needsResolution(props.src) ? null : props.src,
    };

    this._mounted = false;
  }

  componentDidMount() {
    this._mounted = true;
    this.maybeResolve(this.props.src);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      // Reset state for new src and re-resolve.
      this.setState({
        resolvedSrc: needsResolution(this.props.src) ? null : this.props.src,
      });
      this.maybeResolve(this.props.src);
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  maybeResolve(src) {
    if (!needsResolution(src)) {
      return;
    }
    resolveSignedUrl(src).then(finalUrl => {
      if (!this._mounted || this.props.src !== src) {
        return;
      }
      this.setState({ resolvedSrc: finalUrl });
    });
  }

  render() {
    // Pass all props through, overriding `src` with the resolved URL when
    // available. While resolution is pending, fall back to the original
    // authorized URL so the browser can attempt to load it (and possibly
    // follow the redirect on its own).
    const src = this.state.resolvedSrc || this.props.src;
    return React.createElement('img', { ...this.props, src });
  }
};
